import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class OrchestrationErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Orchestration Error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          background: 'white',
          borderRadius: '15px',
          padding: '40px',
          boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
          textAlign: 'center',
          border: '2px solid #e74c3c',
        }}>
          <div style={{ fontSize: '3em', marginBottom: '20px' }}>⚠️</div>
          <h2 style={{ color: '#e74c3c', marginBottom: '15px' }}>
            Orchestration Error
          </h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            Something went wrong with the orchestration system. 
            The demo will continue in legacy mode.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{
              background: '#3498db',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            🔄 Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default OrchestrationErrorBoundary;